import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../auth/AuthContext';
import useGlobalShortcut from './useGlobalShortcut';

const LANGUAGES = ['en', 'fr', 'de', 'it'];

const useLanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const { user, updateUserPreferences } = useAuth();

  const switchToNextLanguage = useCallback(async () => {
    try {
      const currentIndex = LANGUAGES.indexOf(i18n.language);
      const nextIndex = (currentIndex + 1) % LANGUAGES.length;
      const nextLanguage = LANGUAGES[nextIndex];
      
      // Change language in i18n first
      i18n.changeLanguage(nextLanguage);
      
      if (user) {
        // Update preferences in the backend
        await updateUserPreferences({
          ...user.preferences,
          language: nextLanguage
        });
      }
      
      // Save to localStorage as fallback
      localStorage.setItem('preferredLanguage', nextLanguage);
    } catch (error) {
      console.error('Error updating language preference:', error);
      // Revert language change if save failed
      i18n.changeLanguage(user?.preferences?.language || 'en');
    }
  }, [i18n, user, updateUserPreferences]);

  // Register Ctrl+L shortcut
  useGlobalShortcut('l', switchToNextLanguage);

  return {
    currentLanguage: i18n.language,
    switchToNextLanguage,
    availableLanguages: LANGUAGES
  };
};

export default useLanguageSwitcher; 